import axios from 'axios';

const service = axios.create({
    baseURL:
        process.env.NODE_ENV === 'development'
            ? 'http://127.0.0.1:3333'
            : 'https://nyxz166.cn/message/api',
    timeout: 5000
});

service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        if (!error.response) {
            return Promise.reject(error);
        }
        return Promise.reject(error.response.data.msg);
    }
);

service.interceptors.response.use(
    response => {
        if (response && response.status !== 200) {
            return Promise.reject(response);
        } else {
            return response;
        }
    },
    error => {
        if (!error.response) {
            return Promise.reject(error);
        }
        return Promise.reject(error.response.data.msg);
    }
);

export default service;
